import React from 'react';
import Accordion from '../objects/accordion/Accordion';
import Anchor from '../objects/Anchor';
import { accordionNavigationGb, accordionNavigationUs } from './navigationData';
import { siteOfOriginHelper } from '../../../helpers/genericHelpers';


const Navigation = props => {

	const { navClass='' } = props;

	//navAnchors looks at the same data source and for each one creates a ul with an anchor inside getting the name and path from our Object, the path is passed to the anchor component

	const navAnchors = (data) => {
		
		return data.map( item => {
			return (
			<li className="navigation-list__item" key={ item.path }>
				<Anchor internal path={item.path} anchorClass={'navigation-link'} >
					{item.name}
				</Anchor>
			</li>
			)
		})
	};

	// buildNav takes the data and maps over it returning a ul for each main tab coming from the data source and inside calls the navAnchors function to map over the indiviudal links

	const buildNav = (data) => {

		return data.map( item => {
			const isActive = !!item.anchors.find( anchor => (anchor.path.indexOf( 'partnerships' ) > -1 && window.location.pathname.indexOf( 'partnerships' ) > -1 && !window.location.pathname.includes( anchor.path )) || window.location.pathname.includes( anchor.path ) );

			return (
				<ul className="navigation-list"
					title={item.accordionItem.name}
					btnClass={`navigation__heading-text ${ isActive ? 'active' : '' }`}
					icon={true}
					iconName={item.accordionItem.icon}
					iconWidth={'16px'}
					isOpen={false}
					key={ item.accordionItem.name }>
					{navAnchors(item.anchors)}
				</ul>
			);
		});
	};
	const siteOfOrigin = siteOfOriginHelper()
	const navData = siteOfOrigin === 'gb' ? accordionNavigationGb : accordionNavigationUs
	
	return (
		// Here we return our Accordion component, this contains an accordian item and it takes a ul for each one containing the title and icon name etc, inside this Accordion we call the buildNav function above with accordionNavigation as the params, this is a data file with an array of objects for us to map over.
		<nav className={`navigation-section ${ navClass }`}>
			<Accordion>
			 {buildNav(navData)}
			</Accordion>						
		</nav>
	)
};

export default Navigation;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/Navigation.js